import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const userMerchant = {
  namespaced: true,

  state() {
    return {
      allUsers: [],
      totalUsers: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      totalPage: 0,
      usersMerchantDetail: [],
      usersMerchant: [],
      totalUsersMerchant: 0,

      BioDetailList: [],
      BioTotalList: 0,
      BioTotalPage: 0,

      listUserRole: [],
      merchantList: [],
    };
  },

  mutations: {
    setUsers(state, { payload }) {
      state.allUsers = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearUsers(state) {
      state.allUsers = [];
      state.totalUsers = 0;
    },

    setDetailMerchant(state, { payload }) {
      state.usersMerchantDetail = payload;
      state.usersMerchant = payload;
    },

    clearUsersMerchant(state) {
      state.usersMerchant = [];
      state.totalUsersMerchant = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalUsers(state, { payload }) {
      state.totalUsers = parseInt(payload.data.countData, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    editUser(state, { payload, index }) {
      Object.assign(state.allUsers[index], payload);
    },

    setBioList(state, { payload }) {
      state.BioDetailList = payload.data.list;
    },

    setTotalBio(state, { payload }) {
      state.BioTotalList = parseInt(payload.data.countdata, 10);
    },

    clearBioList(state) {
      state.BioDetailList = [];
      state.BioTotalList = 0;
    },

    setRole(state, { payload }) {
      state.listUserRole = payload.data;
    },
    setMerchant(state, { payload }) {
      state.merchantList = payload.data;
    },
    clearMerchant(state) {
      state.merchantList = [];
    },
  },

  actions: {
    async fetchUsers(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, type }
    ) {
      ctx.commit('clearUsers');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const data = JSON.stringify({
        search,
        sortBy: sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const dataUrl = (typeVal) =>
        typeVal === 'portal' ? 'portal-merchant' : 'mobile-merchant';

      const urlApi = `/index.php?r=api/v1/user_merchant/${dataUrl(type)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalUsers', {
          payload: responseData,
        });
        ctx.commit('setUsers', { payload: responseData });
      }
    },

    async updateUser(ctx, { date, user, change_password, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: user.id.toString(),
        username: user.username,
        change_password,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user_merchant/merchant/update`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        const updatedUser = responseData.data;
        ctx.commit('editUser', {
          payload: updatedUser,
          index,
        });
        resVal = true;
      }
      return resVal;
    },

    async viewMerchant(
      ctx,
      { id, date, page, itemsPerPage, sortBy, sortDesc, search, type }
    ) {
      ctx.commit('clearUsersMerchant');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const data = JSON.stringify({
        id,
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const dataUrl = (typeVal) =>
        typeVal === 'portal' ? 'portal-merchant' : 'mobile-merchant';

      const urlApi = `/index.php?r=api/v1/user_merchant/${dataUrl(type)}/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalUsers', {
          payload: responseData,
        });
        ctx.commit('setDetailMerchant', {
          payload: responseData.data,
        });
      }
    },

    async viewBiometricStatus(ctx, { id, date, page, itemsPerPage }) {
      ctx.commit('clearBioList');
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user_merchant/merchant/biometric-status`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setBioList', {
          payload: responseData,
        });
        ctx.commit('setTotalBio', {
          payload: responseData,
        });
      }
    },

    async getRole(ctx, { date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user_merchant/search/get-user-role`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setRole', {
          payload: responseData,
        });
      }
    },

    async getMerchant(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        limit: 10,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user_merchant/search/get-mid-account`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setMerchant', {
          payload: responseData,
        });
      }
    },
  },
};

export default userMerchant;
